import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';

let brand = pageLayer[0].brand;

const SliderNavContainer = styled.div`
	left: 0;
	right: 0;
	z-index: 3;
	text-align: center;
	margin: 10px 0;
	.slider-nav {
		display: inline-block;
		.btn-slick {
			background-color: #fff;
			border: none;
			box-shadow: none;
			outline: none;
      padding: 4px;

      .osw & {
        padding-top: 1px;
      }
		}
		.btn-slick-left {
			float: left;
		}
		.btn-slick-right {
			float: right;
		}
		.slider-dots-container {
      // margin: 0 5px;
      // .law & {
      //   margin: 2px 5px;
      // }
			position: relative;
			bottom: auto;
			width: auto;
			height: 20px;
			display: inline-flex;
			top: 4px;

			.slider-dot button {
				margin: 0 5px;
				border-radius: 50px;
				padding: 0;
				outline: none;
				height: 12px;
				width: 12px;
				border: 2px solid #b7b7b7;
				background-color: #b7b7b7;
			}
			.slider-dot button.active {
				border: 2px solid #b7b7b7;
				background-color: #fff;
			}
		}
	}
}`;

const SlickNav = props => {
  let renderDots = () => {
    let dots = [];
    for (let i = 0; i < props.dotCount; i++) {
      let activeSlide = props.activeSlide === i ? 'active' : '';
      let index = i;

      if (props.slidesToShow !== 1) {
        activeSlide = props.activeSlide / props.slidesToShow === i ? 'active' : '';
        index = i * props.slidesToShow;
      }

      /*
				Create the Dots
			 */
      dots.push(
        <li className="slider-dot" key={i}>
          <button className={activeSlide} onClick={() => props.goToSlide(index)} type="button" />
        </li>,
      );
    }

    return dots;
  };

  return (
    <SliderNavContainer className="slider-nav-container col-xs-12 no-pad">
      <div className="slider-nav">
        <button className="btn btn-slick btn-slick-left" onClick={() => props.previousSlide()}>
          <span>
            <img
              src={
                brand === 'osw'
                  ? '/images/us/osw/common/icons/circle-arrow-left.svg'
                  : `/images/us/common/icons/${brand}/angle_left_regular.svg`
              }
              alt="left"
              height="10px"
              width="10px"
            />
          </span>
        </button>
        <ul className="slider-dots-container">{renderDots()}</ul>
        <button className="btn btn-slick btn-slick-right" onClick={() => props.nextSlide()}>
          <span>
            <img
              src={
                brand === 'osw'
                  ? '/images/us/osw/common/icons/circle-arrow-right.svg'
                  : `/images/us/common/icons/${brand}/angle_right_regular.svg`
              }
              alt="right"
              height="10px"
              width="10px"
            />
          </span>
        </button>
      </div>
    </SliderNavContainer>
  );
};

/*
     Define Prop types
 */
SlickNav.propTypes = {
  dotCount: PropTypes.number.isRequired,
  activeSlide: PropTypes.number.isRequired,
  previousSlide: PropTypes.func.isRequired,
  goToSlide: PropTypes.func.isRequired,
  nextSlide: PropTypes.func.isRequired,
  slidesToShow: PropTypes.number.isRequired,
};

export default SlickNav;
